import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import DataSource from "../../../types/DataSource"


export interface componentProps {
    item: DataSource
}

const ItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.info')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel>{t('data-sources.form.name')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.name || '-'}</IonNote>
            </IonItem>
            {item.dataSourceType &&
                <IonItem lines="full">
                    <IonLabel>{t('common.type')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">
                        {item.dataSourceType.name}
                    </IonNote>
                </IonItem>
            }
            <IonItem lines="full">
                <IonLabel>{t('common.is_enabled')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.isEnabled ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>
                    {t('data-sources.form.skipExistingFullName')}
                </IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.skipExistingFullName ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('data-sources.form.skipExistingEmail')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.skipExistingEmail ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ItemGroupInfo